import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user_category",
  "use": "icon-user_category-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user_category\"><defs><style type=\"text/css\"></style></defs><path d=\"M694.272 245.76H369.95072l-129.61792-57.20064 74.38336-66.9696 438.72256-1.536L823.296 181.98528z m-367.59552 42.55744L253.48096 405.504l-175.84128-68.21888 0.57344-2.7648L194.56 229.80608zM860.16 214.528l128.9216 114.13504-198.08256 76.84096-69.77536-111.63648L860.16 225.28v-10.752zM369.29536 307.2H675.84l46.77632 124.7232-48.08704 18.6368H369.95072l-48.08704-18.6368L368.64 307.2l-5.14048-2.58048z m-137.58464 156.24192L532.48 983.04 59.26912 425.984l6.26688-30.49472zM532.48 983.04z m-182.04672-471.04h343.61344l33.0752-13.53728L532.48 983.04 317.44 498.46272z m652.43136-126.34112l7.5776 40.63232L532.48 983.04l280.28928-519.59808zM532.48 983.04z\" p-id=\"1753\" fill=\"\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user_category.svg
// module id = SUkd
// module chunks = 100